import { render } from "./Venue.vue?vue&type=template&id=6b18f222"
import script from "./Venue.vue?vue&type=script&lang=js"
export * from "./Venue.vue?vue&type=script&lang=js"

import "./Venue.vue?vue&type=style&index=0&id=6b18f222&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Venue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b18f222"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b18f222', __exports__)) {
    api.reload('6b18f222', __exports__)
  }
  
  module.hot.accept("./Venue.vue?vue&type=template&id=6b18f222", () => {
    api.rerender('6b18f222', render)
  })

}


export default __exports__